(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('history-loader', {
            parent: 'admin',
            url: '/history-loader',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'history-loader.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/history-loader/history-loader.html',
                    controller: 'HistoryLoaderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('history-loader');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('history-loader.dialog', {
            parent: 'history-loader',
            url: '/load-history',
            params: {
                requestParams: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/history-loader/history-loader-dialog.html',
                    controller: 'HistoryLoaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: $stateParams.requestParams
                    }
                }).result.then(function() {
                    $state.go('history-loader.loading');
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('history-loader.loading', {
            parent: 'history-loader.dialog',
            url: '/loading-history',
            views: {
                'content@': {
                    templateUrl: 'app/admin/history-loader/history-loader-loading.html',
                    controller: 'HistoryLoaderLoadingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', function ($stateParams) {
                    return {
                        historyProviderSelector: $stateParams.requestParams.historyProviderSelector
                    }
                }]
            }
        }).state('history-loader.retransmission-dialog', {
            parent: 'history-loader',
            url: '/loading-history-retransmission',
            params: {
                requestParams: null
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/history-loader/history-loader-retransmission-dialog.html',
                    controller: 'HistoryLoaderRetransmissionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: $stateParams.requestParams
                    }
                }).result.then(function() {
                    $state.go('history-loader.retransmission-loading');
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('history-loader.retransmission-loading', {
            parent: 'history-loader.retransmission-dialog',
            url: '/loading-history-retransmission',
            views: {
                'content@': {
                    templateUrl: 'app/admin/history-loader/history-loader-retransmission-loading.html',
                    controller: 'HistoryLoaderRetransmissionLoadingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', function ($stateParams) {
                    return {
                        historyProviderSelector: $stateParams.requestParams.historyProviderSelector
                    }
                }]
            }
        });
    }
})();
